import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'reactstrap';
import moment from 'moment';
import { environment } from '../../../environment/environment';
import CustomToolTip from '../../../components/Tooltip/CustomToolTip';
import { AuditLog } from './types';

interface EmployeeRiskAuditTrailProps {
  employeeId: number;
  refreshTrigger?: number;
}

const EmployeeRiskAuditTrail: React.FC<EmployeeRiskAuditTrailProps> = ({
  employeeId,
  refreshTrigger,
}) => {
  const [riskyAuditLogs, setRiskyAuditLogs] = useState<AuditLog[]>([]);
  const [riskyAuditLogsLoading, setRiskyAuditLogsLoading] = useState(false);

  useEffect(() => {
    getRiskyAuditLogs();
  }, [refreshTrigger]);

  const getRiskyAuditLogs = () => {
    setRiskyAuditLogsLoading(true);
    axios
      .get(`${environment.baseUrl}/employee/risky-audit-trail/`, {
        params: {
          employee_id: employeeId,
        },
      })
      .then((res) => {
        setRiskyAuditLogs(
          Array.isArray(res.data) ? res.data : res.data.results || []
        );
        setRiskyAuditLogsLoading(false);
      })
      .catch(() => {
        setRiskyAuditLogsLoading(false);
      });
  };

  return (
    <div>
      <hr className="mt-4 mb-3" />
      <h4 className="mb-3">Change History</h4>
      {riskyAuditLogsLoading ? (
        <div className="text-center py-3">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : riskyAuditLogs.length === 0 ? (
        <p className="text-muted text-center">No change history</p>
      ) : (
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Risky</th>
                <th scope="col">Reason</th>
                <th scope="col">Updated By</th>
              </tr>
            </thead>
            <tbody>
              {riskyAuditLogs.map((log, index) => {
                const reasonText = log.reasons?.join(', ') || '';
                const isLong = reasonText.length > 40;
                const tooltipId = `reason-tooltip-${index}`;

                return (
                  <tr key={index}>
                    <td>{moment(log.date).format('DD MMM YY h:mm a')}</td>
                    <td>
                      {log.risky !== null && log.risky !== undefined && (
                        <span
                          className={`badge badge-${log.risky ? 'danger' : 'success'}`}
                        >
                          {log.risky ? 'Yes' : 'No'}
                        </span>
                      )}
                    </td>
                    <td>
                      {isLong ? (
                        <>
                          <span id={tooltipId}>
                            {reasonText.substring(0, 40)}...
                          </span>
                          <CustomToolTip id={tooltipId}>
                            {reasonText}
                          </CustomToolTip>
                        </>
                      ) : (
                        reasonText
                      )}
                    </td>
                    <td>{log.updatedBy || ''}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
    </div>
  );
};

export default EmployeeRiskAuditTrail;
